// extracted by mini-css-extract-plugin
export default {"uploadRosterTitle":"uploadRosterTitle-xAtLU","uploadRosterButton":"uploadRosterButton-npl1N","title":"title-bj8Jo","breakLine":"breakLine-vZWui"};